import { useParams, useNavigate } from "react-router-dom";
import "/src/assets/css/orderdetails/orderdetails.css";
import useOrderDetails from "../../hooks/useOrderDetails";
import { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import axios from "axios";
import { toast } from "react-toastify";
import SafeImage from "../../components/common/SafeImage";
import proof from "../../assets/img/img.png"
export default function OrderDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const printRef = useRef();
  const [showImageModal, setShowImageModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [openReAssign, setOpenReAssign] = useState(false);
  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState("");
  const [reason, setReason] = useState("");
  const [driversLoading, setDriversLoading] = useState(false);
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [orderDetails, setOrderDetails] = useState(null);
  // Add to your component state
  const [searchTerm, setSearchTerm] = useState("");
  const [reasonError, setReasonError] = useState("");

  // Filter drivers based on search term
  const filteredDrivers = drivers.filter(
    (driver) =>
      driver.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      driver.driver_id.toString().includes(searchTerm)
  );

  // Update your handleReAssign function to disable everything during loading
  // and clear error on modal close
  useEffect(() => {
    if (!openReAssign) {
      setReasonError("");
      setSearchTerm("");
    }
  }, [openReAssign]);
  const { order, isLoading, error } = useOrderDetails(id);

  const downloadPDF = () => {
    window.print();
  };

  const printInvoice = () => {
    window.print();
  };

  const openImageModal = () => {
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setShowImageModal(false);
  };

  const downloadImage = () => {
    if (order?.proof_image) {
      // Extract filename from the URL
      const filename = order.proof_image.split("/").pop();
      const downloadUrl = `${import.meta.env.VITE_API_URL
        }/api/download-delivery-proof/${filename}`;

      // Trigger download
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `delivery-proof-${order.order_code || order.order_id}.jpg`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };
  // Format date function
  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleString("en-US", {
        timeZone: "UTC", // Force UTC
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
    } catch {
      return dateString;
    }
  };

  const handleReAssign = async () => {
    if (selectedDrivers.length === 0) {
      alert("Please select at least one driver");
      return;
    }

    setLoading(true);

    try {
      await axios.post(
        `${import.meta.env.VITE_API_URL}/api/admin/orders/reassign-driver`,
        {
          order_id: order.order_id,
          driver_ids: selectedDrivers,
          reason: reason,
        },
        {
          withCredentials: true,
        }
      );

      toast.success("Driver(s) reassigned successfully!");
      setOpenReAssign(false);
      window.location.reload();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to reassign driver");
    } finally {
      setLoading(false);
    }
  };

  const fetchNearbyDrivers = async () => {
    setDriversLoading(true);
    setDrivers([]);
    setSelectedDriver("");

    try {
      const res = await axios.get(
        `${import.meta.env.VITE_API_URL}/api/admin/nearby-drivers`,
        {
          params: { order_id: order.order_id },
          withCredentials: true,
        }
      );

      setDrivers(res.data.data.drivers || []);
      setOrderDetails(res.data.data.order_details);
    } catch (error) {
      alert(error.response?.data?.message || "Failed to load nearby drivers");
    } finally {
      setDriversLoading(false);
    }
  };

  // Get current year for copyright
  const currentYear = new Date().getFullYear();

  if (isLoading) return <div className="od-loading-container">Loading...</div>;
  if (error || !order)
    return (
      <div className="od-error-container">
        <h4>{error?.message || "Order Not Found"}</h4>
        <button onClick={() => navigate("/order")}>Back</button>
      </div>
    );

  return (
    <>
      {/* Main Content */}
      <div className="od-container no-print">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="od-card">
                {/* Action Buttons */}
                <div className="od-actions">
                  <button
                    onClick={() => window.history.back()}
                    className="od-btn-back"
                  >
                    <i className="fas fa-arrow-left"></i>
                    Back
                  </button>
                  <div className="od-action-buttons">
                    {/* <button onClick={downloadPDF} className="od-btn-download">
                      <i className="fas fa-download"></i>
                      Save as PDF
                    </button> */}
                    <button onClick={printInvoice} className="od-btn-print">
                      <i className="fas fa-print"></i>
                      Print Invoice
                    </button>
                  </div>
                </div>

                <div className="od-card-body">
                  <div className="od-header">
                    <div className="od-title">
                      <h3>Order #{order.order_code || order.order_id}</h3>
                      <span
                        className={`od-status-badge od-status-${order.status?.toLowerCase()}`}
                      >
                        {order.status}
                      </span>
                    </div>
                    <div className="od-meta">
                      <div className="od-meta-item">
                        <i className="fas fa-calendar"></i>
                        <span>
                          {order.ordered_at
                            ? new Date(order.ordered_at).toLocaleDateString()
                            : "-"}
                        </span>
                      </div>
                      <div className="od-meta-item">
                        <span>
                          {order.order_items?.[0]?.currency_symbol || ""}{" "}
                          {order.total_amount}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="od-content">
                    <div className="row g-4">
                      <div className="col-xl-8">
                        {/* Customer & Shipping Info - Side by side like image 2 & 3 */}
                        <div className="od-info-section">
                          <div className="od-info-inline">
                            {/* Customer Info Card with Profile Image */}
                            <div className="od-section-card od-customer-card">
                              <h4 className="od-section-title">
                                <i className="fas fa-user"></i>
                                Customer Details
                              </h4>
                              <div className="od-customer-content">
                                <div className="od-customer-avatar">
                                  {order.customer?.user?.profile_image ? (
                                    <SafeImage
                                      src={order.customer?.user?.profile_image}
                                      alt="Profile"
                                      className="od-avatar-img"
                                    />
                                  ) : (
                                    <div className="od-avatar-placeholder">
                                      <i className="fas fa-user"></i>
                                    </div>
                                  )}
                                </div>
                                <div className="od-customer-details">
                                  <div className="od-customer-name">
                                    {order.customer ? (
                                      <Link
                                        to={`/customerdetails/${order.customer_id}`}
                                        style={{
                                          color: "#007bff",
                                          textDecoration: "underline",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {order.customer.user?.name || "Unknown"}
                                      </Link>
                                    ) : (
                                      "Null"
                                    )}
                                  </div>
                                  <div className="od-customer-contact">
                                    <i className="fas fa-envelope"></i>
                                    {order.customer?.user?.email || "-"}
                                  </div>
                                  <div className="od-customer-contact">
                                    <i className="fas fa-phone"></i>
                                    {order.customer?.user?.phone_no || "-"}
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Shipping Address Card */}
                            <div className="od-section-card od-address-card">
                              <h4 className="od-section-title">
                                <i className="fas fa-map-marker-alt"></i>
                                Shipping Address
                              </h4>
                              <div className="od-address-content">
                                <p className="od-address-text">
                                  {order.customer_address ||
                                    "No shipping address provided"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Order Items */}
                        <div className="od-section-card od-items-card">
                          <h4 className="od-section-title">
                            <i className="fas fa-shopping-cart"></i>
                            Order Items
                          </h4>
                          <div className="od-table-responsive">
                            <table className="od-items-table">
                              <thead>
                                <tr>
                                  <th>Product</th>
                                  <th>Vendor</th>
                                  <th>Quantity</th>
                                  <th>Price</th>
                                  <th>Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {order.order_items &&
                                  order.order_items.map((item, idx) => (
                                    <tr key={idx}>
                                      <td>
                                        <div className="od-product-info">
                                          <SafeImage
                                            src={
                                              item.product?.product_image
                                                ? JSON.parse(
                                                  item.product.product_image
                                                )[0]
                                                : "/placeholder-product.png"
                                            }
                                            alt={item.product?.product_name}
                                            className="od-product-img"
                                            onError={(e) => {
                                              e.target.src =
                                                "/placeholder-product.png";
                                            }}
                                          />
                                          <span className="od-product-name">
                                            {item.product?.product_name}
                                          </span>
                                        </div>
                                      </td>
                                      <td>
                                        <Link
                                          to={`/vendordetails/${item?.vendor_product?.vendor?.vendor_id}`}
                                          style={{
                                            color: "#007bff",
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {item?.vendor_product?.vendor?.user
                                            ?.name || "N/A"}
                                        </Link>
                                      </td>

                                      <td className="od-quantity">
                                        {item.quantity}
                                      </td>
                                      <td className="od-price">
                                        {order.order_items?.[0]
                                          ?.currency_symbol || ""}{" "}
                                        {parseFloat(item.price).toFixed(2)}
                                      </td>
                                      <td className="od-total">
                                        {order.order_items?.[0]
                                          ?.currency_symbol || ""}{" "}
                                        {(
                                          item.quantity * parseFloat(item.price)
                                        ).toFixed(2)}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {/* Shipping Details Section - Compact UI */}
                        {order.status?.toLowerCase() !== "pending" && (
                          <div className="od-section-card od-shipping-card">
                            <div className="od-shipping-header">
                              <h4 className="od-shipping-title">
                                <i className="fas fa-truck"></i>
                                Shipping Details
                              </h4>
                              <div
                                style={{
                                  display: "flex",
                                  gap: 10,
                                  alignItems: "center",
                                }}
                              >
                                {order.status?.toLowerCase() === "ongoing" && (
                                  <button
                                    className="btn btn-sm btn-warning"
                                    onClick={() => {
                                      if (order?.order_id) {
                                        setOpenReAssign(true);
                                        fetchNearbyDrivers();
                                      } else {
                                        console.error("Order not loaded yet");
                                      }
                                    }}
                                  >
                                    ReAssign Driver
                                  </button>
                                )}
                              </div>

                              <div className="od-shipping-status">
                                <span
                                  className={`od-status-indicator od-status-${order.status?.toLowerCase()}`}
                                >
                                  <i className="fas fa-circle"></i>
                                  {order.status || "Pending"}
                                </span>
                              </div>
                            </div>

                            <div className="od-shipping-grid-compact">
                              {/* Driver Information */}
                              <div className="od-shipping-driver-card">
                                <div className="od-driver-header">
                                  <i className="fas fa-id-card"></i>
                                  <h5>Driver Information</h5>
                                </div>
                                <div className="od-driver-details">
                                  <div className="od-driver-detail">
                                    <i className="fas fa-user"></i>
                                    <div>
                                      <span className="od-detail-label">
                                        Driver Name
                                      </span>
                                      <span className="od-detail-value">
                                        {order.driver ? (
                                          <Link
                                            to={`/driverdetails/${order.driver_id}`}
                                            style={{
                                              color: "#007bff",
                                              textDecoration: "underline",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {order.driver.user?.name ||
                                              "No Name"}
                                          </Link>
                                        ) : (
                                          "Not Assigned"
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="od-driver-detail">
                                    <i className="fas fa-phone"></i>
                                    <div>
                                      <span className="od-detail-label">
                                        Phone
                                      </span>
                                      <span className="od-detail-value">
                                        {order.driver?.user?.phone_no || "N/A"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Delivery Timeline - Side by side with Proof Image */}
                              <div className="od-timeline-proof-wrapper">
                                <div className="od-timeline-card">
                                  <div className="od-timeline-header">
                                    <i className="fas fa-history"></i>
                                    <h5>Delivery Timeline</h5>
                                  </div>
                                  <div className="od-timeline-compact">
                                    <div className="od-timeline-item od-assigned">
                                      <i className="fas fa-user-check od-timeline-icon-small"></i>
                                      <div className="od-timeline-content">
                                        <span className="od-timeline-title">
                                          Order Assigned
                                        </span>
                                        <span className="od-timeline-time">
                                          {formatDateTime(order.assigned_at)}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="od-timeline-item od-delivered">
                                      <i className="fas fa-check-circle od-timeline-icon-small"></i>
                                      <div className="od-timeline-content">
                                        <span className="od-timeline-title">
                                          Delivery Completed
                                        </span>
                                        <span className="od-timeline-time">
                                          {formatDateTime(order.completed_at)}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Delivery Proof - Side by side with Timeline */}
                                {order.proof_image && (
                                  <div className="od-proof-card">
                                    <div className="od-proof-header">
                                      <i className="fas fa-camera"></i>
                                      <h5>Delivery Proof</h5>
                                    </div>
                                    <div className="od-proof-content-compact">
                                      <div className="od-proof-image-container-small">
                                        <SafeImage
                                          src={`${import.meta.env.VITE_API_URL
                                            }${order.proof_image}`}
                                          alt="Delivery Proof"
                                          className="od-proof-thumbnail-small"
                                          onClick={openImageModal}
                                          onError={(e) => {
                                            e.target.src =proof;
                                          }}
                                        />
                                        <div
                                          className="od-proof-overlay-small"
                                          onClick={openImageModal}
                                        >
                                          <i className="fas fa-search-plus"></i>
                                        </div>
                                      </div>
                                      <button
                                        className="od-proof-view-btn-small"
                                        onClick={openImageModal}
                                      >
                                        <i className="fas fa-expand"></i> View
                                        Image
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="col-xl-4">
                        <div className="od-summary">
                          {/* Order Details */}
                          <div className="od-section-card od-details-card">
                            <h4 className="od-section-title">
                              <i className="fas fa-info-circle"></i>
                              Order Details
                            </h4>
                            <div className="od-details-list">
                              <div className="od-detail-item">
                                <span className="od-detail-label">
                                  Order ID
                                </span>
                                <span className="od-detail-value">
                                  {order.order_id}
                                </span>
                              </div>
                              <div className="od-detail-item">
                                <span className="od-detail-label">
                                  Order Date
                                </span>
                                <span className="od-detail-value">
                                  {order.ordered_at
                                    ? new Date(
                                      order.ordered_at
                                    ).toLocaleDateString()
                                    : "-"}
                                </span>
                              </div>
                              <div className="od-detail-item">
                                <span className="od-detail-label">
                                  Payment Method
                                </span>
                                <span className="od-detail-value od-payment-method">
                                  {order.payment?.payment_method || "-"}
                                </span>
                              </div>
                              <div className="od-detail-item">
                                <span className="od-detail-label">
                                  Delivery Status
                                </span>
                                <span
                                  className={`od-detail-value od-status-text od-status-${order.status?.toLowerCase()}`}
                                >
                                  {order.status}
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Order Summary */}
                          <div className="od-section-card od-pricing-card">
                            <h4 className="od-section-title">
                              <i className="fas fa-receipt"></i>
                              Order Summary
                            </h4>
                            <div className="od-pricing-details">
                              <div className="od-pricing-row">
                                <span className="od-pricing-label">
                                  Subtotal
                                </span>
                                <span className="od-pricing-value">
                                  {order.order_items?.[0]?.currency_symbol ||
                                    ""}{" "}
                                  {parseFloat(
                                    order.subtotal_amount || 0
                                  ).toFixed(2)}
                                </span>
                              </div>
                              <div className="od-pricing-row">
                                <span className="od-pricing-label">
                                  Shipping
                                </span>
                                <span className="od-pricing-value">
                                  {order.order_items?.[0]?.currency_symbol ||
                                    ""}{" "}
                                  {parseFloat(
                                    order.shipping_amount || 0
                                  ).toFixed(2)}
                                </span>
                              </div>
                              <div className="od-pricing-row">
                                <span className="od-pricing-label">
                                  Service
                                </span>
                                <span className="od-pricing-value">
                                  {order.order_items?.[0]?.currency_symbol ||
                                    ""}{" "}
                                  {parseFloat(
                                    order.service_charge || 0
                                  ).toFixed(2)}
                                </span>
                              </div>
                              <div className="od-pricing-row">
                                <span className="od-pricing-label">Tax</span>
                                <span className="od-pricing-value">
                                  {order.order_items?.[0]?.currency_symbol ||
                                    ""}{" "}
                                  {parseFloat(order.tax_amount || 0).toFixed(2)}
                                </span>
                              </div>
                              <div className="od-pricing-row od-discount">
                                <span className="od-pricing-label">
                                  Discount
                                </span>
                                <span className="od-pricing-value">
                                  {order.order_items?.[0]?.currency_symbol ||
                                    ""}{" "}
                                  {parseFloat(
                                    order.discount_amount || 0
                                  ).toFixed(2)}
                                </span>
                              </div>
                              <div className="od-pricing-row od-total">
                                <span className="od-pricing-label">Total</span>
                                <span className="od-pricing-value">
                                  {order.order_items?.[0]?.currency_symbol ||
                                    ""}{" "}
                                  {parseFloat(order.total_amount || 0).toFixed(
                                    2
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Order Notes */}
                          {order.notes && (
                            <div className="od-section-card od-notes-card">
                              <h4 className="od-section-title">
                                <i className="fas fa-sticky-note"></i>
                                Order Notes
                              </h4>
                              <div className="od-notes-content">
                                {order.notes}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Footer */}
                  {/* <div className="od-footer">
                    <div className="od-footer-content">
                      <div className="od-company-info">
                        <h5>Go Home Express</h5>
                        <p>Thank you for your order!</p>
                      </div>
                      <div className="od-copyright">
                        Copyright {currentYear} © Go Home Express
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {showImageModal && order?.proof_image && (
        <div className="od-image-modal-overlay" onClick={closeImageModal}>
          <div className="od-image-modal" onClick={(e) => e.stopPropagation()}>
            <div className="od-modal-header">
              <h3>
                <i className="fas fa-camera"></i>
                Delivery Proof - Order #{order.order_code || order.order_id}
              </h3>
              <button className="od-modal-close" onClick={closeImageModal}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="od-modal-body">
              <div className="od-modal-image-container">
                <SafeImage
                  src={`${import.meta.env.VITE_API_URL}${order.proof_image}`}
                  alt="Delivery Proof"
                  className="od-modal-image"
                  onError={(e) => {
                    e.target.src = proof;
                  }}
                />
              </div>
            </div>
            <div className="od-modal-footer">
              <div className="od-modal-meta">
                <span className="od-modal-meta-item">
                  <i className="fas fa-user"></i>
                  Driver: {order.driver?.user?.name || "N/A"}
                </span>
                <span className="od-modal-meta-item">
                  <i className="fas fa-clock"></i>
                  Delivered: {formatDateTime(order.completed_at)}
                </span>
              </div>
              <div className="od-modal-actions">
                <button
                  className="od-modal-download-btn"
                  onClick={downloadImage}
                >
                  <i className="fas fa-download"></i> Download Image
                </button>
                <button
                  className="od-modal-close-btn"
                  onClick={closeImageModal}
                >
                  <i className="fas fa-times"></i> Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Print Only Content - Hidden from screen */}
      <div className="od-print-container" ref={printRef}>
        <div className="od-invoice-wrapper">
          {/* Invoice Header */}
          <div className="od-invoice-header">
            <div className="od-company-info-print">
              <h1>Go Home Express</h1>
              <p>Your trusted delivery partner</p>
            </div>
            <div className="od-invoice-title">
              <h2>INVOICE</h2>
              <p>Order #{order.order_code || order.order_id}</p>
            </div>
          </div>

          {/* Order Header */}
          <div className="od-print-header">
            <div className="od-print-order-info">
              <h3>Order #{order.order_code || order.order_id}</h3>
              <span
                className={`od-status-badge od-status-${order.status?.toLowerCase()}`}
              >
                {order.status}
              </span>
            </div>
            <div className="od-print-meta">
              <div className="od-print-meta-item">
                <i className="fas fa-calendar"></i>
                <span>
                  {order.ordered_at
                    ? new Date(order.ordered_at).toLocaleDateString()
                    : "-"}
                </span>
              </div>
              <div className="od-print-meta-item">
                <span>
                  {order.order_items?.[0]?.currency_symbol || ""}{" "}
                  {parseFloat(order.total_amount || 0).toFixed(2)}
                </span>
              </div>
            </div>
          </div>

          {/* Customer & Shipping Info */}
          <div className="od-print-info-section">
            <div className="od-print-info-inline">
              {/* Customer Info */}
              <div className="od-print-customer-card">
                <h4 className="od-print-section-title">
                  <i className="fas fa-user"></i>
                  Customer Details
                </h4>
                <div className="od-print-customer-content">
                  <div className="od-print-customer-avatar">
                    {order.customer?.user?.profile_image ? (
                      <SafeImage
                        src={order.customer?.user?.profile_image}
                        alt="Profile"
                        className="od-print-avatar-img"
                      />
                    ) : (
                      <div className="od-print-avatar-placeholder">
                        <i className="fas fa-user"></i>
                      </div>
                    )}
                  </div>
                  <div className="od-print-customer-details">
                    <div className="od-print-customer-name">
                      {order.customer?.user?.name || "-"}
                    </div>
                    <div className="od-print-customer-contact">
                      <i className="fas fa-envelope"></i>
                      {order.customer?.user?.email || "-"}
                    </div>
                    <div className="od-print-customer-contact">
                      <i className="fas fa-phone"></i>
                      {order.customer?.user?.phone_no || "-"}
                    </div>
                  </div>
                </div>
              </div>

              {/* Shipping Address */}
              <div className="od-print-address-card">
                <h4 className="od-print-section-title">
                  <i className="fas fa-map-marker-alt"></i>
                  Shipping Address
                </h4>
                <div className="od-print-address-content">
                  <p className="od-print-address-text">
                    {order.customer_address || "No shipping address provided"}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Order Items */}
          <div className="od-print-items-section">
            <h4 className="od-print-section-title">
              <i className="fas fa-shopping-cart"></i>
              Order Items
            </h4>
            <div className="od-print-table-responsive">
              <table className="od-print-items-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Vendor</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {order.order_items &&
                    order.order_items.map((item, idx) => (
                      <tr key={idx}>
                        <td>
                          <div className="od-print-product-info">
                            <SafeImage
                              src={
                                item.product?.product_image
                                  ? JSON.parse(item.product.product_image)[0]
                                  : "/placeholder-product.png"
                              }
                              alt={item.product?.product_name}
                              className="od-print-product-img"
                              onError={(e) => {
                                e.target.src = "/placeholder-product.png";
                              }}
                            />
                            <span className="od-print-product-name">
                              {item.product?.product_name}
                            </span>
                          </div>
                        </td>
                        <td>
                          {item?.vendor_product?.vendor?.user?.name || "N/A"}
                        </td>
                        <td className="od-print-quantity">{item.quantity}</td>
                        <td className="od-print-price">
                          {order.order_items?.[0]?.currency_symbol || ""}{" "}
                          {parseFloat(item.price).toFixed(2)}
                        </td>
                        <td className="od-print-total">
                          {order.order_items?.[0]?.currency_symbol || ""}{" "}
                          {(item.quantity * parseFloat(item.price)).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Shipping Details for Print - Fixed side by side layout */}
          {order.status?.toLowerCase() !== "pending" && (
            <div className="od-print-shipping-section">
              <h4 className="od-print-section-title">
                <i className="fas fa-truck"></i>
                Shipping & Delivery Details
              </h4>

              <div className="od-print-shipping-grid">
                {/* Driver Information Card - LEFT SIDE */}
                <div className="od-print-driver-card">
                  <h5>
                    <i className="fas fa-id-card"></i>
                    Driver Information
                  </h5>
                  <div className="od-print-driver-details">
                    <div className="od-print-driver-row">
                      <div className="od-print-driver-label">
                        <i className="fas fa-user"></i>
                        <span>Driver Name:</span>
                      </div>
                      <span className="od-print-driver-value">
                        {order.driver?.user?.name || "Not Assigned"}
                      </span>
                    </div>
                    <div className="od-print-driver-row">
                      <div className="od-print-driver-label">
                        <i className="fas fa-phone"></i>
                        <span>Phone:</span>
                      </div>
                      <span className="od-print-driver-value">
                        {order.driver?.user?.phone_no || "N/A"}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Delivery Timeline Card - RIGHT SIDE */}
                <div className="od-print-timeline-card">
                  <h5>
                    <i className="fas fa-clock"></i>
                    Delivery Timeline
                  </h5>
                  <div className="od-print-timeline-items">
                    <div className="od-print-timeline-item">
                      <div className="od-print-timeline-label">
                        <i className="fas fa-user-check"></i>
                        <span>Order Assigned:</span>
                      </div>
                      <span className="od-print-timeline-value">
                        {order.assigned_at
                          ? formatDateTime(order.assigned_at)
                          : "N/A"}
                      </span>
                    </div>
                    <div className="od-print-timeline-item">
                      <div className="od-print-timeline-label">
                        <i className="fas fa-check-circle"></i>
                        <span>Delivery Completed:</span>
                      </div>
                      <span className="od-print-timeline-value">
                        {order.completed_at
                          ? formatDateTime(order.completed_at)
                          : "N/A"}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Delivery Proof - Full width below both cards */}
                {order.proof_image && (
                  <div className="od-print-proof-section">
                    <div className="od-print-proof-header">
                      <i className="fas fa-camera"></i>
                      <h5>Delivery Proof</h5>
                    </div>
                    <div className="od-print-proof-content">
                      <SafeImage
                        src={
                          order?.proof_image
                            ? `${import.meta.env.VITE_API_URL}${order.proof_image
                            }`
                            : proof
                        }
                        alt="Delivery Proof"
                        className="od-print-proof-img"
                        onError={(e) => {
                          e.target.src = proof;
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Order Summary & Details */}
          <div className="od-print-summary-section">
            <div className="od-print-summary-grid">
              {/* Order Details */}
              <div className="od-print-details-card">
                <h4 className="od-print-section-title">
                  <i className="fas fa-info-circle"></i>
                  Order Details
                </h4>
                <div className="od-print-details-list">
                  <div className="od-print-detail-item">
                    <span className="od-print-detail-label">Order ID</span>
                    <span className="od-print-detail-value">
                      {order.order_id}
                    </span>
                  </div>
                  <div className="od-print-detail-item">
                    <span className="od-print-detail-label">Order Date</span>
                    <span className="od-print-detail-value">
                      {order.ordered_at
                        ? new Date(order.ordered_at).toLocaleDateString()
                        : "-"}
                    </span>
                  </div>
                  <div className="od-print-detail-item">
                    <span className="od-print-detail-label">
                      Payment Method
                    </span>
                    <span className="od-print-detail-value od-print-payment-method">
                      {order.payment?.payment_method || "-"}
                    </span>
                  </div>
                  <div className="od-print-detail-item">
                    <span className="od-print-detail-label">
                      Delivery Status
                    </span>
                    <span
                      className={`od-print-detail-value od-print-status-text od-status-${order.status?.toLowerCase()}`}
                    >
                      {order.status}
                    </span>
                  </div>
                </div>
              </div>

              {/* Order Summary */}
              <div className="od-print-pricing-card">
                <h4 className="od-print-section-title">
                  <i className="fas fa-receipt"></i>
                  Order Summary
                </h4>
                <div className="od-print-pricing-details">
                  <div className="od-print-pricing-row">
                    <span className="od-print-pricing-label">Subtotal</span>
                    <span className="od-print-pricing-value">
                      {order.order_items?.[0]?.currency_symbol || ""}{" "}
                      {parseFloat(order.subtotal_amount || 0).toFixed(2)}
                    </span>
                  </div>
                  <div className="od-print-pricing-row">
                    <span className="od-print-pricing-label">Shipping</span>
                    <span className="od-print-pricing-value">
                      {order.order_items?.[0]?.currency_symbol || ""}{" "}
                      {parseFloat(order.shipping_amount || 0).toFixed(2)}
                    </span>
                  </div>
                  <div className="od-print-pricing-row">
                    <span className="od-print-pricing-label">Service</span>
                    <span className="od-print-pricing-value">
                      {order.order_items?.[0]?.currency_symbol || ""}{" "}
                      {parseFloat(order.service_charge || 0).toFixed(2)}
                    </span>
                  </div>
                  <div className="od-print-pricing-row">
                    <span className="od-print-pricing-label">Tax</span>
                    <span className="od-print-pricing-value">
                      {order.order_items?.[0]?.currency_symbol || ""}{" "}
                      {parseFloat(order.tax_amount || 0).toFixed(2)}
                    </span>
                  </div>
                  <div className="od-print-pricing-row od-print-discount">
                    <span className="od-print-pricing-label">Discount</span>
                    <span className="od-print-pricing-value">
                      {order.order_items?.[0]?.currency_symbol || ""}{" "}
                      {parseFloat(order.discount_amount || 0).toFixed(2)}
                    </span>
                  </div>
                  <div className="od-print-pricing-row od-print-total">
                    <span className="od-print-pricing-label">Total</span>
                    <span className="od-print-pricing-value">
                      {order.order_items?.[0]?.currency_symbol || ""}{" "}
                      {parseFloat(order.total_amount || 0).toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="od-print-footer">
            <div className="od-print-footer-content">
              <div className="od-print-company-final">
                <h5>Go Home Express</h5>
                <p>Thank you for your business!</p>
              </div>
              <div className="od-print-copyright">
                Copyright {currentYear} © Go Home Express
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={openReAssign}
        onClose={() => !loading && setOpenReAssign(false)}
        sx={{
          "& .MuiBackdrop-root": {
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95vw", sm: "520px" },
            maxWidth: "520px",
            maxHeight: "90vh",
            bgcolor: "background.paper",
            boxShadow: "0px 20px 60px rgba(0, 0, 0, 0.25)",
            borderRadius: "16px",
            p: 0,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: "24px 24px 20px 24px",
              borderBottom: "1px solid rgba(255, 255, 255, 0.15)",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              opacity: loading ? 0.7 : 1,
              transition: "opacity 0.3s ease",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  width: "44px",
                  height: "44px",
                  borderRadius: "12px",
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span style={{ color: "white", fontSize: "22px" }}>🚚</span>
              </div>
              <div>
                <h4
                  style={{
                    margin: 0,
                    fontWeight: "700",
                    color: "white",
                    fontSize: "18px",
                  }}
                >
                  Assign Delivery Drivers
                </h4>
                <p
                  style={{
                    margin: "6px 0 0 0",
                    fontSize: "14px",
                    color: "rgba(255, 255, 255, 0.9)",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <span>📦</span>
                  Order #{orderDetails?.order_id}
                </p>
              </div>
            </div>
          </div>

          {/* Search */}
          <div
            style={{
              padding: "20px 24px",
              borderBottom: "1px solid #f0f0f0",
              backgroundColor: "#fafafa",
              opacity: loading ? 0.7 : 1,
              transition: "opacity 0.3s ease",
            }}

            className="reassing-driver-model"
          >
            <div style={{ position: "relative" }}>
              <input
                type="text"
                placeholder="Search drivers by name or ID..."
                value={searchTerm}
                onChange={(e) => !loading && setSearchTerm(e.target.value)}
                disabled={loading}
                style={{
                  paddingLeft: "48px",
                  paddingRight: "40px",
                  borderRadius: "10px",
                  border: "1px solid #e1e1e1",
                  fontSize: "14px",
                  height: "46px",
                  backgroundColor: loading ? "#f5f5f5" : "white",
                  width: "100%",
                  outline: "none",
                  cursor: loading ? "not-allowed" : "text",
                  opacity: loading ? 0.6 : 1,
                  transition: "all 0.3s ease",
                }}
              />
              <span
                style={{
                  position: "absolute",
                  left: "16px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: loading ? "#ccc" : "#999",
                  fontSize: "16px",
                }}
              >
                🔍
              </span>
              {searchTerm && !loading && (
                <button
                  onClick={() => setSearchTerm("")}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    color: "#999",
                    cursor: "pointer",
                    fontSize: "16px",
                    padding: "4px",
                  }}
                >
                  ✕
                </button>
              )}
            </div>
          </div>

          {/* Driver Section */}
          <div

            className="reassing-driver-model"
            style={{
              padding: "20px 24px",
              borderBottom: "1px solid #f0f0f0",
              maxHeight: "400px",
              overflowY: "auto",
              opacity: loading ? 0.7 : 1,
              transition: "opacity 0.3s ease",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "4px",
                  }}
                >
                  <span>👥</span>
                  <span
                    style={{
                      fontWeight: "600",
                      fontSize: "16px",
                      color: loading ? "#aaa" : "#333",
                    }}
                  >
                    Available Drivers
                  </span>
                </div>
                <small
                  style={{ fontSize: "13px", color: loading ? "#ccc" : "#666" }}
                >
                  Select one or more drivers to assign this order
                </small>
              </div>
              <div
                style={{
                  backgroundColor: loading
                    ? "#f0f0f0"
                    : selectedDrivers.length > 0
                      ? "#e7f4ff"
                      : "#f8f9fa",
                  padding: "6px 12px",
                  borderRadius: "20px",
                  border: loading
                    ? "1px solid #e8e8e8"
                    : selectedDrivers.length > 0
                      ? "1px solid #b6d4fe"
                      : "1px solid #e0e0e0",
                }}
              >
                <span
                  style={{
                    fontSize: "13px",
                    color: loading
                      ? "#aaa"
                      : selectedDrivers.length > 0
                        ? "#0d6efd"
                        : "#666",
                    fontWeight: "600",
                  }}
                >
                  {selectedDrivers.length} selected
                </span>
              </div>
            </div>

            {/* Driver List */}
            <div>
              {filteredDrivers.map((driver) => (
                <div
                  key={driver.driver_id}
                  className="reassing-driver-model"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "16px",
                    marginBottom: "12px",
                    border: loading
                      ? "1px solid #eee"
                      : selectedDrivers.includes(driver.driver_id)
                        ? "2px solid #667eea"
                        : "1px solid #e8e8e8",
                    borderRadius: "12px",
                    backgroundColor: loading
                      ? "#fafafa"
                      : selectedDrivers.includes(driver.driver_id)
                        ? "#f8faff"
                        : "white",
                    cursor: loading ? "not-allowed" : "pointer",
                    opacity: loading ? 0.6 : 1,
                    transition: "all 0.3s ease",
                  }}
                  onClick={() => {
                    if (loading) return;
                    const driverId = driver.driver_id;
                    if (selectedDrivers.includes(driverId)) {
                      setSelectedDrivers(
                        selectedDrivers.filter((id) => id !== driverId)
                      );
                    } else {
                      setSelectedDrivers([...selectedDrivers, driverId]);
                    }
                  }}
                >
                  {/* Avatar */}
                  <div
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "10px",
                      background: loading
                        ? "#f0f0f0"
                        : selectedDrivers.includes(driver.driver_id)
                          ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                          : "#f5f5f5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "16px",
                      opacity: loading ? 0.7 : 1,
                    }}
                  >
                    <span
                      style={{
                        color: loading
                          ? "#bbb"
                          : selectedDrivers.includes(driver.driver_id)
                            ? "white"
                            : "#555",
                        fontWeight: "700",
                        fontSize: "18px",
                      }}
                    >
                      {driver.name.charAt(0)}
                    </span>
                  </div>

                  {/* Driver Info */}
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        marginBottom: "8px",
                      }}
                    >
                      <div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "6px",
                          }}
                        >
                          <span
                            style={{
                              fontWeight: "600",
                              fontSize: "15px",
                              color: loading ? "#bbb" : "#333",
                            }}
                          >
                            {driver.name}
                          </span>
                          <span
                            style={{
                              fontSize: "12px",
                              color: loading ? "#ccc" : "#666",
                              backgroundColor: loading ? "#f0f0f0" : "#f5f5f5",
                              padding: "3px 8px",
                              borderRadius: "10px",
                            }}
                          >
                            ID: {driver.driver_id}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <span
                            style={{
                              color: loading ? "#bbb" : "#28a745",
                              fontWeight: "500",
                              fontSize: "12px",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <div
                              style={{
                                width: "6px",
                                height: "6px",
                                borderRadius: "50%",
                                backgroundColor: loading ? "#ddd" : "#28a745",
                                animation: loading
                                  ? "none"
                                  : "pulse 2s infinite",
                              }}
                            ></div>
                            Available
                          </span>
                          <span
                            style={{
                              fontSize: "13px",
                              color: loading ? "#ccc" : "#666",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            📍 {driver.distance_km} km away
                          </span>
                        </div>
                      </div>

                      {/* Distance Box */}
                      <div style={{ textAlign: "right" }}>
                        <div
                          style={{
                            fontSize: "16px",
                            color: loading ? "#bbb" : "#333",
                            fontWeight: "700",
                            marginBottom: "2px",
                          }}
                        >
                          {driver.distance_km} km
                        </div>
                        <div
                          style={{
                            fontSize: "11px",
                            color: loading ? "#ddd" : "#999",
                          }}
                        >
                          Distance
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Checkbox */}
                  <div style={{ marginLeft: "12px" }}>
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "4px",
                        border: loading
                          ? "2px solid #eee"
                          : selectedDrivers.includes(driver.driver_id)
                            ? "2px solid #667eea"
                            : "2px solid #ddd",
                        backgroundColor: loading
                          ? "#f5f5f5"
                          : selectedDrivers.includes(driver.driver_id)
                            ? "#667eea"
                            : "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: loading ? "not-allowed" : "pointer",
                      }}
                    >
                      {selectedDrivers.includes(driver.driver_id) && (
                        <span style={{ color: "white", fontSize: "12px" }}>
                          ✓
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Reason Section */}
          <div
            style={{
              padding: "24px",
              borderBottom: "1px solid #f0f0f0",
              opacity: loading ? 0.7 : 1,
              transition: "opacity 0.3s ease",
            }}


            className="reassing-driver-model"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "12px",
              }}
            >
              <span>📝</span>
              <span
                style={{
                  fontWeight: "600",
                  fontSize: "15px",
                  color: loading ? "#aaa" : "#333",
                }}
              >
                Reason for Reassignment{" "}
                <span style={{ color: loading ? "#ff9999" : "red" }}>*</span>
              </span>
            </div>

            <textarea

              className="reassing-driver-model"
              placeholder="Explain why you're reassigning this order (e.g., driver unavailable, priority delivery, etc.)"
              value={reason}
              onChange={(e) => !loading && setReason(e.target.value)}
              disabled={loading}
              style={{
                width: "100%",
                minHeight: "100px",
                padding: "12px",
                borderRadius: "8px",
                border: loading ? "1px solid #eee" : "1px solid #e1e1e1",
                fontSize: "14px",
                lineHeight: "1.5",
                resize: "vertical",
                outline: "none",
                marginBottom: "8px",
                backgroundColor: loading ? "#f5f5f5" : "#fafafa",
                cursor: loading ? "not-allowed" : "text",
                opacity: loading ? 0.6 : 1,
                transition: "all 0.3s ease",
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <small
                style={{
                  fontSize: "12px",
                  color: loading ? "#ccc" : "#999",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                💡 Required for tracking and quality purposes
              </small>
              <small
                style={{
                  fontSize: "12px",
                  color: loading
                    ? "#ccc"
                    : reason.length > 450
                      ? "#ff6b6b"
                      : "#999",
                }}
              >
                {reason.length}/500
              </small>
            </div>
          </div>

          {/* Footer Buttons */}
          <div
            style={{
              padding: "20px 24px",
              backgroundColor: "#fafafa",
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
            }}

            className="reassing-driver-model"
          >
            <button
              onClick={() => !loading && setOpenReAssign(false)}
              disabled={loading}
              style={{
                padding: "10px 20px",
                fontSize: "14px",
                fontWeight: "600",
                borderRadius: "8px",
                border: loading ? "1px solid #eee" : "1px solid #ddd",
                backgroundColor: loading ? "#f5f5f5" : "white",
                color: loading ? "#ccc" : "#555",
                cursor: loading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                opacity: loading ? 0.6 : 1,
                transition: "all 0.3s ease",
              }}
            >
              ✕ Cancel
            </button>

            <button
              onClick={() => {
                // Validation
                if (!reason.trim()) {
                  toast.error("Please provide a reason for reassignment");
                  return;
                }
                if (selectedDrivers.length === 0) {
                  toast.error("Please select at least one driver");
                  return;
                }

                // Start loading
                setLoading(true);

                // Call your assignment function
                handleReAssign();
              }}
              disabled={loading}
              style={{
                padding: "10px 24px",
                fontSize: "14px",
                fontWeight: "700",
                borderRadius: "8px",
                border: "none",
                backgroundColor: loading ? "#a1a9e8" : "#667eea",
                color: "white",
                cursor: loading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                opacity: loading ? 0.8 : 1,
                transition: "all 0.3s ease",
              }}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    style={{
                      width: "12px",
                      height: "12px",
                      borderWidth: "2px",
                    }}
                  ></span>
                  Sending...
                </>
              ) : (
                <>📤 Send to Drivers ({selectedDrivers.length})</>
              )}
            </button>
          </div>
        </Box>
      </Modal>

      <style>
        {`
    @keyframes pulse {
      0% { opacity: 1; }
      50% { opacity: 0.5; }
      100% { opacity: 1; }
    }
    
    .spinner-border {
      display: inline-block;
      width: 1rem;
      height: 1rem;
      vertical-align: text-bottom;
      border: 0.2em solid currentColor;
      border-right-color: transparent;
      border-radius: 50%;
      animation: spinner-border .75s linear infinite;
    }
    
    @keyframes spinner-border {
      to { transform: rotate(360deg); }
    }
  `}
      </style>
    </>
  );
}
